import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { z } from 'zod';
import { Welcome } from '@/features/welcome/Welcome.tsx';
import { requireAuthenticated } from '@/common/api/requireAuthenticated';

export const Route = createFileRoute('/welcome')({
  beforeLoad: requireAuthenticated,
  head: () => ({ meta: [{ title: 'Welcome' }] }),
  validateSearch: z
    .object({
      continueTo: z.string().optional(),
      continueSearch: z.any().optional(),
    })
    .optional()
    .default({}),
  search: {
    middlewares: [
      stripSearchParams({ continueTo: '/portal/start', continueSearch: {} }),
    ],
  },
  component: Welcome,
});
